export const parseJwt = token => {
  if (token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
    //verifyTokenSignature --> to be implemented
    return JSON.parse(jsonPayload);
  }
};

export const getAccount = payload => (Object.prototype.hasOwnProperty.call(payload, 'account') ? payload.account : null);

export const getIdClienteLef = payload => (Object.prototype.hasOwnProperty.call(payload, 'idClienteLef') ? payload.idClienteLef : null);

export const getIdResponsable = payload => (Object.prototype.hasOwnProperty.call(payload, 'idResponsable') ? payload.idResponsable : null);

export const getUserId = payload => (
  Object.prototype.hasOwnProperty.call(payload, 'idClienteNavision') ?
    payload.idClienteNavision :
    Object.prototype.hasOwnProperty.call(payload, 'idLexonUser') ?
      payload.idLexonUser :
      Object.prototype.hasOwnProperty.call(payload, 'nameUser') ?
        payload.nameUser :
        Object.prototype.hasOwnProperty.call(payload, 'userId') ?
          payload.userId :
          null
);

export const getIdClienteNavision = payload => (Object.prototype.hasOwnProperty.call(payload, 'idClienteNavision') ? payload.idClienteNavision : null);

export const getRoles = payload => (Object.prototype.hasOwnProperty.call(payload, 'roles') ? payload.roles : null);

export const getUserName = payload => (Object.prototype.hasOwnProperty.call(payload, 'name') ? payload.name : null);

export const getIdApp = payload => (Object.prototype.hasOwnProperty.call(payload, 'idApp') ? payload.idApp : null);

export const getIdUserApp = payload => (Object.prototype.hasOwnProperty.call(payload, 'idUserApp') ? payload.idUserApp : null);

export const getIdUser = payload => (Object.prototype.hasOwnProperty.call(payload, 'idUser') ? payload.idUser : null);

export const getLogin = payload => (Object.prototype.hasOwnProperty.call(payload, 'login') ? payload.login : null);

export const getIdCasefile = payload =>
  ((Object.prototype.hasOwnProperty.call(payload, 'idEntityType') &&
    Object.prototype.hasOwnProperty.call(payload, 'idEntity')) ?
    ((payload.idEntityType == 1) ? payload.idEntity : null) : null);

export const getBbdd = payload => (Object.prototype.hasOwnProperty.call(payload, 'bbdd') ? payload.bbdd : null);

export const getIdCompany = payload => (
  Object.prototype.hasOwnProperty.call(payload, 'companyId') ?
    payload.companyId : Object.prototype.hasOwnProperty.call(payload, 'idCompany') ?
      payload.idCompany : null
);

export const getIdLexon = payload => (Object.prototype.hasOwnProperty.call(payload, 'idLexon') ? payload.idLexon : null);

export const getIdMail = payload => (Object.prototype.hasOwnProperty.call(payload, 'idMail') ? payload.idMail : null);

export const getImapFolder = payload => {
  if (payload && payload.folder) {
    if (payload.folder.indexOf("::") !== -1) {
      return payload.folder.split("::")[1].toUpperCase();
    }
    return payload.folder.toUpperCase();
  }
  return null;
};

export const getIdEntityType = payload => (Object.prototype.hasOwnProperty.call(payload, 'idEntityType') ? payload.idEntityType : null);

export const getIdEntity = payload => (Object.prototype.hasOwnProperty.call(payload, 'idEntity') ? payload.idEntity : null);

export const getMailContacts = payload => (Object.prototype.hasOwnProperty.call(payload, 'mailContacts') ? payload.mailContacts.toString() : null);

export const getIdActuation = payload => (Object.prototype.hasOwnProperty.call(payload, 'idActuation') ? payload.idActuation : null);

export const getIdCalendar = payload => (Object.prototype.hasOwnProperty.call(payload, 'idCalendar') ? payload.idCalendar : null);

export const getIdEvent = payload => (Object.prototype.hasOwnProperty.call(payload, 'idEvent') ? payload.idEvent : null);

export const getTitle = payload => (Object.prototype.hasOwnProperty.call(payload, 'title') ? payload.title : null);

export const getEnv = payload => (Object.prototype.hasOwnProperty.call(payload, 'env') ? payload.env : null);

export const getAppConnect = payload => (Object.prototype.hasOwnProperty.call(payload, 'appConnect') ? payload.appConnect : null);

// PEC-1557: consentimiento de cookies aceptado en Lexon (claim booleano `accept_cookies` emitido por UserUtils).
// Devuelve siempre un booleano: solo `true` estricto cuenta como aceptado; ausente o cualquier otro valor => false.
export const getAcceptCookies = payload => Boolean(payload && payload.accept_cookies === true);

export const getDocumentsId = payload => (Object.prototype.hasOwnProperty.call(payload, 'documentsId') ? payload.documentsId : null);

export const getInterveners = payload => (Object.prototype.hasOwnProperty.call(payload, 'interveners') ? payload.interveners : null);

export const getSubject = payload => (Object.prototype.hasOwnProperty.call(payload, 'subject') ? payload.subject : null);

export const getIsCompose = payload => (Object.prototype.hasOwnProperty.call(payload, 'compose') ? payload.compose : null);

export const getUrlType = payload => {
  if (Object.prototype.hasOwnProperty.call(payload, 'idMail') && getIdCasefile(payload) == null) {
    return "mailOnly";
  } else if (Object.prototype.hasOwnProperty.call(payload, 'idMail') && getIdEntityType(payload) == 1) {
    return "mailWithCaseFile";
  } else if (getIdEntityType(payload) !== null && getIdEntityType(payload) > 1 && getIdEntityType(payload) < 13) {
    return "composeWithContacts";
  } else if (getIdCasefile(payload) != null) {
    return "composeWithCaseFile";
  } else if (Object.prototype.hasOwnProperty.call(payload, 'bbdd')) {
    return "dbOnly";
  }

  return "default";
};
